
class AnchorMenu extends HTMLElement {
  constructor() {
    super();

    this.isScrolling = null;
    this.linkActive = this.linkActive;

    this.anchorLinks.forEach(link => link.addEventListener('click', () => this.bindAnchor(link.getAttribute('data-anchor-id'))));


    window.addEventListener('scroll', () => {
      // 判断是否是anthor menu section
      if (this.anchorMenuSection) {
        // 在滚动时判断是否显示锚点菜单
        this.setNavPosition();
      }
      this.updateActiveLink();
    });

  }

  get anchorMenuSection() {
    return this.closest('.anthor-menu-section');
  }

  get anchorLinks() {
    // 获取锚点菜单
    return Array.from(this.querySelectorAll('ul.anchor-menu li'));
  }

  get anchorContents() {
    return this.anchorLinks.map(link => {
      return document.getElementById(link.getAttribute('data-anchor-id'));
    }).filter(Boolean);
  }

  get linkActive() {
    return (this.anchorLinks.find(link => link.classList.contains('active')) || this.anchorLinks[0]).getAttribute('data-anchor-id');
  }

  set linkActive(id) {
    this.anchorLinks.forEach((link) => {
      link.classList.remove('active'); // 移除所有链接的活动类
      if (link.getAttribute('data-anchor-id') === `${id}`) {
        link.classList.add('active'); // 为当前锚点添加活动类
      }
    });
  }

  // 检查第一个block元素是否进入视图
  get hasFirstBlockElement() {
    if (!this.anchorContents[0]) return false;

    // 检查元素是否在视图中
    const rect = this.anchorContents[0].getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // 元素进入视图的条件：元素顶部小于窗口高度
    return rect.top < windowHeight;
  }

  bindAnchor(id) {
    const targetElement = document.getElementById(id);
    if (targetElement) {
      targetElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    // 清除之前的定时器
    clearTimeout(this.isScrolling);
    // 设置一个新的定时器
    this.isScrolling = setTimeout(() => {
      this.linkActive = id; // 执行滚动结束后的操作
    }, 200); // 设置200毫秒的延迟
  }

  updateActiveLink() {
    let currentId = '';
    for (const anchorContent of this.anchorContents) {
      const sectionTop = anchorContent.getBoundingClientRect().top;
      // 检查当前锚点菜单对应的section是否在视口内
      if (sectionTop > 0 && sectionTop < window.innerHeight) {
        currentId = anchorContent.id;
        break;
      }
    }
    if (!currentId) {
      return;
    }
    this.linkActive = currentId;
  }

  // 根据第一个block元素的存在情况设置导航样式
  setNavPosition() {
    if (this.hasFirstBlockElement) {
      this.anchorMenuSection.style.top = 0;
      // document.querySelectorAll('.shopify-section-group-header-group').forEach(header => header.style.display = 'none');
    } else {
      this.anchorMenuSection.style.top = '-300px';
      // document.querySelectorAll('.shopify-section-group-header-group').forEach(header => header.style.display = '');
    }
  }

}
if (!customElements.get('anchor-menu')) {
  customElements.define('anchor-menu', AnchorMenu);
}
